import { useMemo } from 'react';
import { cn, PaletteUtils } from '@shared/utils';
import styles from './styles.module.css';

const OrientationTypeEnum = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
} as const;
type OrientationTypeEnum = (typeof OrientationTypeEnum)[keyof typeof OrientationTypeEnum];
type OrientationType = OrientationTypeEnum | `${OrientationTypeEnum}`;

interface RadioProps {
  className?: string;
  orientation: OrientationType;
  options?: {
    text: string;
    value: string;
  }[];
  readonly?: boolean;
  value?: string;
  onChange?: (val: string) => void;
}

export const Radio = (props: RadioProps) => {
  const isVertical = useMemo(() => props.orientation === OrientationTypeEnum.Vertical, [props.orientation]);

  return (
    <div className={cn('flex w-full border-none p-0', isVertical ? 'flex-col' : 'flex-row', props.className)}>
      {props.options?.map((item, key) => (
        <div
          key={key}
          className={cn(
            'flex cursor-pointer items-center rounded-bl-md rounded-tl-md pr-2 dark:bg-soft-black',
            isVertical ? 'mb-1 rounded border-[1px] border-black px-3 py-2 dark:border-gray-white' : 'mr-3',
            props.readonly && 'border-gray-400',
            styles.item,
          )}
          onClick={() => !props.readonly && props.onChange?.(item.value)}
        >
          <input
            className={cn(styles.radio, PaletteUtils.isVcfcPalette && styles.vcfc, PaletteUtils.isPersonalPalette && styles.personal)}
            type='radio'
            readOnly={props.readonly}
            value={item.value}
            checked={item.value === props.value}
            onChange={() => {}}
          />
          <label className={cn(props.readonly && 'text-gray-400')}>{item.text}</label>
        </div>
      ))}
    </div>
  );
};
